export default function initMaterializeCss() {
  M.AutoInit();

  // Datepicker
  const elems = document.querySelectorAll(".datepicker");
  elems.forEach((elem) => {
    const options = elem.getAttribute("data-options")
      ? JSON.parse(elem.getAttribute("data-options"))
      : {};

    if (options.minDate === "today") {
      options.minDate = new Date();
    }
    if (options.maxDate === "today") {
      options.maxDate = new Date();
    }

    M.Datepicker.init(elem, {
      autoClose: true,
      firstDay: 1,
      format: "dd/mm/yyyy",
      ...options,
    });
  });
}
